import { combineReducers } from 'redux'

import list from './compartments/list'

export default combineReducers({
  list
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/compartments.js